export const VIEW_MODE = {
  NO_RESTRICTION: 0,
  CROP_INSIDE_CANVAS: 1,
};

export const CroppingToolKind = {
  basic: {
    key: "basic",
    hideAspectRatio: false,
    disableResize: false,
    disableRotate: false,
    disableUndo: false,
    disableReset: false,
    disableZoom: false,
    enableWhitening: false,
    viewMode: VIEW_MODE.NO_RESTRICTION,
  },
  // DND Option - Size defined
  cropping_tool_1: {
    key: "cropping_tool_1",
    hideAspectRatio: true,
    disableResize: true,
    disableRotate: true,
    disableUndo: true,
    disableReset: true,
    disableZoom: true,
    enableWhitening: true,
    viewMode: VIEW_MODE.CROP_INSIDE_CANVAS,
  },
  // DND Option - Size not defined
  cropping_tool_2: {
    key: "cropping_tool_2",
    hideAspectRatio: false,
    disableResize: false,
    disableRotate: true,
    disableUndo: true,
    disableReset: true,
    disableZoom: false,
    enableWhitening: false,
    viewMode: VIEW_MODE.CROP_INSIDE_CANVAS,
  },
  // Featured Image - complete list refer to https://jira.sls.ufinity.com/browse/SLS-9359
  cropping_tool_3: {
    key: "cropping_tool_3",
    hideAspectRatio: true,
    disableResize: false,
    disableRotate: false,
    disableUndo: false,
    disableReset: false,
    disableZoom: false,
    enableWhitening: false,
    viewMode: VIEW_MODE.NO_RESTRICTION,
  },
  // MO & UGC
  // Drawing Canvas
  cropping_tool_4: {
    key: "cropping_tool_4",
    hideAspectRatio: false,
    disableResize: false,
    disableRotate: false,
    disableUndo: false,
    disableReset: false,
    disableZoom: false,
    enableWhitening: false,
    viewMode: VIEW_MODE.NO_RESTRICTION,
  },
};

export const zoomRatio = 0.15;
export const wheelZoomRatio = 0.15;

export const CROP_ACTION = {
  ASPECT_RATIO: "aspectRatio",
  ROTATE: "rotate",
  UNDO: "undo",
  CLEAR: "clear",
  ZOOM_IN: "zoomIn",
  ZOOM_OUT: "zoomOut",
  ZOOM_DEFAULT: "zoomDefault",
};

export const IMAGE_DIMENSION_LIMIT = {
  HEIGHT: 10000,
  WIDTH: 5000,
};
